import React from "react";

export default function Privacy() {
  return (
    <div className="container mt-3">
      <h1 className="headline_text">PRIVACY POLICY</h1>
      <div className="text-left mt-3 content_style">
        <div>
          <h2 className="global_text_color mb-3">Introduction</h2>
          <p className="global_text_color mb-1">
            Hello! Welcome to the DEVOTED HORSES Privacy Policy.
          </p>
          <p className="global_text_color mb-1">
            This page is used to inform visitors regarding our policies for the
            collection, use, and disclosure of Personal Information if anyone
            decided to use our Service.
          </p>
          <p className="global_text_color mb-1">
            If you choose to use our Service, then you agree to the collection
            and use of information in relation to this policy. The Personal
            Information that we collect is used for providing and improving the
            Service. We will not use or share your information with anyone
            except as described in this Privacy Policy.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">The data we may collect</h2>
          <p className="global_text_color mb-1">
            The data we collect depends on the context of your interactions with
            us, the choices you make, including your privacy settings, and the
            products and features you use.
          </p>
          <p className="global_text_color mb-1">
            Most of the data that we collect about you comes directly from you
            when you play our games, or interact with our websites, advertising
            or other Services.
          </p>
          <p className="global_text_color mb-1">
            The data we collect may include:
          </p>
          <ul>
            <li className="global_text_color mb-1">
              data that you provide us with when you fill in forms, answer
              questions or complete surveys when using any our Services, when
              you create an account with us or if you invite your friends to us
              our game and Services;
            </li>
            <li className="global_text_color mb-1">
              your messages to our Services (such as emails and chat logs using
              our messaging systems);
            </li>
            <li className="global_text_color mb-1">
              data about your account and game progress include how you play our
              games and interact with our Services (such as which of our games
              you are playing, the game versions, your progress through the
              games, session time and duration, number of attempts at each level
              and purchase made);
            </li>
            <li className="global_text_color mb-1">
              your device identifiers (such as advertising ID);
            </li>
            <li className="global_text_color mb-1">
              data about your device, such as device name and operating system,
              network state, browser type and language;
            </li>
            <li className="global_text_color mb-1">
              data we collect via cookies and other similar technologies, as
              explained further below;
            </li>
            <li className="global_text_color mb-1">
              data we receive from third party tool if you link a third party
              tool with the Services (such as Facebook, WeChat or Google);
            </li>
            <li className="global_text_color mb-1">
              data we collect about you from other third party companies who
              have obtained your consent or have another legal right to share
              such data with us;
            </li>
            <li className="global_text_color mb-1">
              data for advertising and analytics purposes, so we can provide you
              a better Service;
            </li>
            <li className="global_text_color mb-1">
              other data you choose to give us.
            </li>
          </ul>
          <p className="global_text_color mb-1">
            We may from time to time ask you for your consent to collect other
          </p>
          <p className="global_text_color mb-1">
            information from you or your device. For instance, we may invite you
            to allow us to access your contacts to enable us to invite them to
            play our games with you, if you choose not to allow us collect these
            data, we will not collect the data. If we do this or something
            similar, we will tell you what data we would like to collect, why we
            need it and what we'll use it for.
          </p>
          <p className="global_text_color mb-1">
            By downloading, accessing and/or playing our games or using our
            other Services, you consent to the collection of information about
            you by us.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">Use of the data</h2>
          <p className="global_text_color mb-1">
            We use this data to provide our games and Services to you, including
            for the
          </p>
          <p className="global_text_color mb-1">following purposes:</p>
          <ul>
            <li className="global_text_color mb-1">
              to create accounts and allow you play our games and use our
              Services;
            </li>
            <li className="global_text_color mb-1">to analyze and optimize;</li>
            <li className="global_text_color mb-1">to prevent fraud;</li>
            <li className="global_text_color mb-1">
              to customize in-game offers;
            </li>
            <li className="global_text_color mb-1">
              to provide social features;
            </li>
            <li className="global_text_color mb-1">
              to provide customized services, for example to provide our
              Services in the correct language;
            </li>
            <li className="global_text_color mb-1">
              to respond to your comments and questions;
            </li>
            <li className="global_text_color mb-1">
              to verify your purchases;
            </li>
            <li className="global_text_color mb-1">
              to show personalized advertisements;
            </li>
          </ul>
          <p className="global_text_color mb-1">
            We may also use data for the other purposes set out in this Privacy
            Policy, including for Advertising purposes. We also analyze and use
            the data that we collect on an anonymized or aggregated basis for
            product development, to analyze the performance of our games, to
            troubleshoot and to improve and optimize the games to ensure the
            best player experience for our players as a whole.
          </p>
          <p className="global_text_color mb-1">
            A more detailed description of some of the ways that we use your
            information is set out below and in the other sections of this
            Privacy Policy.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">Advertising</h2>
          <p className="global_text_color mb-1">
            Our games may include advertising for third party(such as Facebook,
            Admob, Vungle, Unity etc.) products and services. By accepting this
            Privacy Policy and downloading or continuing to play our games or
            use our Services, and unless you opt out of interest-based
            advertising as explained in this section, you consent to us and our
            advertising partners collecting and using information about you to
            improve advertising, targeting and measurement systems so that we
            can show you relevant third party ads in our games.
          </p>
          <p className="global_text_color mb-1">
            When you play our games or use our Services, non-personal
            identifiers such as the Android advertising ID and/or Apple's ID for
            advertising (the ‘IDFA’) and other information from your device is
            collected and shared with advertising partners to enable the
            technical delivery of ads to your device.
          </p>
          <p className="global_text_color mb-1">
            Our advertising partners may combine this information with
            information which they have collected about you when you use their
            services (or the websites or services of third parties) in order to
            serve you more relevant ads in our games or to improve the accuracy
            of their targeting and measurement systems.
          </p>
          <p className="global_text_color mb-1">
            You consent to the collection and use of your data for targeting
            advertising purposes by our advertising partners as set out in this
            section and as further described in their privacy policies. We
            recommend that you review our advertising partners’ privacy policies
            for more information.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">
            cookies and similar technologies
          </h2>
          <p className="global_text_color mb-1">
            Like most online services, we and our partners use cookies and
            similar technologies to provide and personalize the Service, analyse
            use, target advertisements and prevent fraud. You can disable
            cookies in your browser settings, but some parts of the Service may
            then not function properly.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">Security</h2>
          <p className="global_text_color mb-1">
            We have taken appropriate steps and followed industry standards to
            secure all personal data stored by our systems. All transactions are
            processed in keeping with the highest security level protocols,
            ensuring that no one can access or use personal information in an
            unauthorized manner.
          </p>
          <p className="global_text_color mb-1">
            However, while we take responsible measures to protect your Personal
            Information, the internet is not a 100% secure environment. We
            cannot guarantee the absolute security of all information
            transmitted or electronically stored. We disclaim any liability for
            any unauthorized access to, disclosure or damage to, theft of, or
            loss of any Personal Information. By using our website and/or our
            software, you acknowledge that you understand and agree to assume
            these risks.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">Your rights</h2>
          <p className="global_text_color mb-1">
            Subject to limitations in applicable law, you are entitled to object
            to or request the restriction of processing of your Personal Data,
            and to request access to, rectification, erasure and portability of
            your own Personal Data.
          </p>
          <p className="global_text_color mb-1">
            Where the use of your information is based on consent, you can
            withdraw this consent at any time without affecting the lawfulness
            of processing based on consent before its withdrawal.
          </p>
          <p className="global_text_color mb-1">
            If you are aware of changes or inaccuracies in your information, you
            should inform us of such changes so that our records may be updated
            or corrected. You may lodge a complaint with a supervisory authority
            if you consider that our processing of your Personal Data infringes
            applicable law.
          </p>
          <p className="global_text_color mb-1">
            We retain your Personal Data as long as needed to provide services
            or products to you, or as required or permitted by applicable laws,
            such as tax and accounting laws.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">Age limits</h2>
          <p className="global_text_color mb-1">
            You must be over a certain age to play our games and use our
            Services, depending on where you live. We do not knowingly collect
            or solicit personal data about or direct or target interest based
            advertising to anyone under the age of 13 or knowingly allow such
            persons to use our Services. If you are under 13, please do not send
            any data about yourself to us, including your name, address,
            telephone number, or email address. No one under the age of 13 may
            provide any personal data. If we learn that we have collected
            personal data about a child under age 13, we will delete that data
            as quickly as possible. If you believe that we might have any data
            from or about a child under the age of 13, please contact us.
          </p>
        </div>

        <div className="mt-3">
          <h2 className="global_text_color mb-3">Agreement</h2>
          <p className="global_text_color mb-1">
            By using the our websites, our games, our products, or our services,
            you signify your understanding of and consent to the Privacy Policy.
            If you do not agree to this policy, we strongly urge you to refrain
            from using the our websites, games, products, and services.
          </p>
        </div>
      </div>
    </div>
  );
}
